import { render, staticRenderFns } from "./showLocality.vue?vue&type=template&id=6f83a6cf"
import script from "./showLocality.vue?vue&type=script&lang=js"
export * from "./showLocality.vue?vue&type=script&lang=js"
import style0 from "./showLocality.vue?vue&type=style&index=0&id=6f83a6cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports